import { Fade, useMediaQuery } from "@mui/material";
import { BlockWrapper, defineBlock } from "@smartfire/js-block-engine";
import clsx from "clsx";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as CloseIcon } from "../../assets/close.svg";
import { Product, Separator } from "../../components";
import style from "./block.module.scss";

const Block = ({ products }) => {
  const [showMore, setShowMore] = useState(false);
  const isMobile = useMediaQuery(`(max-width: ${style.mobileBreakpoint})`);
  // React i18next
  const { t } = useTranslation();

  return !(products?.length > 0) ? null : (
    <BlockWrapper.Div className={style.block}>
      <div className={style.top}>
        <div className={style.title}>{t("Similar products")}</div>

        <Separator className={style.separator} />

        {products?.length > 2 && isMobile && (
          <span
            className={style.showMore}
            onClick={() => setShowMore(!showMore)}
          >
            {showMore ? (
              <Fade in={true} key={1} timeout={500}>
                <span>
                  <CloseIcon />
                  {t("Close")}
                </span>
              </Fade>
            ) : (
              <Fade in={true} key={2} timeout={500}>
                <span>{t("View all")}</span>
              </Fade>
            )}
          </span>
        )}
      </div>

      <div
        className={clsx(
          style.products,
          products?.length > 2 && style.scroll,
          showMore && style.wrap
        )}
      >
        {products.map((product, i) => (
          <Product key={i} product={product} className={style.product} />
        ))}
      </div>
    </BlockWrapper.Div>
  );
};

export default defineBlock({
  Block,
});
